const formatNumberWithCommas = (num?: number | string | null): string => {
  if (num === undefined || num === null) {
    return '';
  }

  // Convert to number if it's a string
  const numberValue = typeof num === 'string' ? parseFloat(num) : num;

  if (isNaN(numberValue)) {
    return '';
  }

  const parts = numberValue.toString().split('.');

  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  const formattedNumber = parts[1] ? `${integerPart}.${parts[1]}` : integerPart;

  return formattedNumber;
};

export default formatNumberWithCommas;
